module.exports = kolibriGlobal.coreVue.vuex.store;